import http from './_http'

/**
 * 上传位置
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const reportReportPosition = (params = {}) => {
    return http({
        url: '/report/report_position',
        method: 'post',
        params,
    });
}


/**
 * 上传在线
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const reportReportOnline = (params = {}) => {
    return http({
        url: '/report/report_online',
        method: 'post',
        params,
    });
}
